module.exports = __webpack_public_path__ + "static/media/digital-flyer-success.239e4f2a.svg";